import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@services/AuthService/auth.service';

@Component({
    selector: 'app-wildcard-redirect',
    template: ''
})
export class WildcardRedirectComponent implements OnInit {
    constructor(
        private router: Router,
        private authService: AuthenticationService
    ) {}

    ngOnInit() {
        if (this.authService.isLoggedIn) {
            this.router.navigate(['/dashboard']);
        } else {
            this.router.navigate(['/login']);
        }
    }
}
